export default __webpack_public_path__ + "static/media/logo.ae804985.svg";